import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import MasonryCover from '@/assets/images/masonaryBlock.png';
import ShowcaseCover from '@/assets/images/showcaseCover.png';

gsap.registerPlugin(ScrollTrigger);

const ProductShowcase: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const coverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (coverRef.current) {
      gsap.fromTo(
        coverRef.current.querySelector('img'),
        { xPercent: 0 },
        {
          xPercent: -5,
          transformOrigin: 'center center',
          ease: 'none',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top bottom',
            end: 'bottom bottom',
            scrub: true,
            // markers: true,
          },
        }
      );
    }
  }, []);

  return (
    <div ref={sectionRef} className="tw-text-white tw-bg-black">
      {/* Header */}
      <div className="tw-pt-20 tw-pb-16 tw-px-6 tw-text-center">
        <h1 className="tw-text-2xl md:tw-text-5xl tw-font-bold tw-mb-2">
          Any product.
        </h1>
        <h1 className="tw-text-2xl md:tw-text-5xl tw-font-bold tw-mb-2">
          Any industry.
        </h1>
        <h2 className="tw-text-2xl md:tw-text-5xl tw-font-bold tw-text-[#00C5FB] tw-mb-4 lg:tw-mb-8">
          All good.
        </h2>
        <p className="tw-text-sm md:tw-text-xl tw-text-white tw-max-w-2xl tw-mx-auto tw-leading-relaxed">
          The end-to-end solution for everyone, from<br />
          furniture to fine jewelry, mattresses to motors,<br />
          bikes and beyond.
        </p>
      </div>

      {/* Masonry Cover (on top) */}
      <div
        ref={coverRef}
        className="tw-relative tw-w-full tw-my-8 tw-overflow-visible tw-z-20"
      >
        <img
          src={MasonryCover}
          alt="Masonry"
          className="tw-w-full tw-h-auto tw-object-contain"
        />
      </div>

      {/* Background + overlay + text (behind Masonry) */}
      <div
        className="tw-relative tw-min-h-screen tw-z-10"
        style={{ marginTop: '-25vh' }}
      >
        {/* Background image */}
        <div className="tw-absolute tw-inset-0 tw-z-0">
          <img
            src={ShowcaseCover}
            alt="Workspace"
            className="tw-w-full tw-h-full tw-object-cover"
          />
        </div>

        {/* Semi‑transparent overlay */}
        <div
          className="tw-absolute tw-inset-0 tw-z-10"
          style={{
            background: 'linear-gradient(to bottom, rgba(0,0,0,1) 15%, rgba(0,0,0,0.65) 100%)',
          }}
        />

        {/* Overlay text */}
        <div
          className="tw-relative tw-z-20 tw-flex tw-items-center tw-justify-center tw-h-screen tw-px-6 tw-transform lg:tw-translate-x-48"
        >
          <div className="tw-text-center">
            <h2 className="tw-text-4xl md:tw-text-6xl tw-font-bold tw-mb-8 tw-leading-10">
              We've got pros.<br />In different<br />area codes.
            </h2>
            <p className="tw-text-sm md:tw-text-xl tw-text-gray-300 tw-max-w-2xl tw-mx-auto tw-leading-relaxed">
              Our extensive service network across<br />
              India provides expert servicing and<br />
              quality customer service.
            </p>
          </div>
        </div>


      </div>
    </div>
  );
}

export default ProductShowcase;